import { Association } from "../../lib/association-store";

export class OrgAzureTenant extends Association {}
